import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc, addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { 
    Sparkles, Send, Copy, Loader2, LayoutTemplate, Database, 
    Settings, X, BellRing, CheckCircle2, Trash2, Eye, Link as LinkIcon, 
    Image as ImageIcon, BookOpen, MapPin, KeyRound, Type, Store, Phone
} from 'lucide-react';

// ⚠️ PEXELS KEY SAFE HAI (Frontend par rakh sakte hain)
const PEXELS_API_KEY = "31SVa8SDi76JV8kHCUKE0SBqDD7yjRlg8aXZNOyG1pUMM97zhUvRX0Uk"; 

// 👇 AAPKI SECURE CLOUD FUNCTION URLs 👇
const API_GENERATE_SEO = "https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/generateSeoContent"; 
const API_PUBLISH_WP = "https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/publishToWordPress";
const API_FETCH_PENDING = "https://us-central1-whatsapp-autoreply-bot-pivot.cloudfunctions.net/getPendingWpPosts";

const SeoBlogEngine = ({ tenants, setActiveTab }) => {    // 🏢 Client & Form State
    const [selectedTenantId, setSelectedTenantId] = useState("");
    const [niche, setNiche] = useState("It Training Institute");
    const [businessName, setBusinessName] = useState("Pivot Edu Unit");
    const [whatsappPhone, setWhatsappPhone] = useState("");
    const [topic, setTopic] = useState("");
    const [keyword, setKeyword] = useState("");
    const [location, setLocation] = useState("");
    const [formatRule, setFormatRule] = useState("Lesson");
    const [toneRule, setToneRule] = useState("Teacher");
    const [autoImage, setAutoImage] = useState(true);

    // 🧠 AI Client Knowledge State
    const [aiKnowledge, setAiKnowledge] = useState("");
    const [aiRules, setAiRules] = useState("");

    // 🤖 AI Generation State
    const [isGenerating, setIsGenerating] = useState(false);
    const [generatedTitle, setGeneratedTitle] = useState("");
    const [generatedHtml, setGeneratedHtml] = useState("");
    const [coverImage, setCoverImage] = useState(null);
    const [seoData, setSeoData] = useState(null);

    // 🌐 WordPress State (PER CLIENT)
    const [isPublishing, setIsPublishing] = useState(false);
    const [wpConfig, setWpConfig] = useState({ url: '', username: '', appPassword: '' });
    const [showWpModal, setShowWpModal] = useState(false);
    
    // 🚦 Admin Approval State
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [pendingBlogs, setPendingBlogs] = useState([]);
    const [isFetchingPending, setIsFetchingPending] = useState(false);

    // 📊 NAYA CODE: Leads Modal State
    const [showLeadsModal, setShowLeadsModal] = useState(false);
    const [blogLeads, setBlogLeads] = useState([
        { date: "4/11/2026", name: "New Rank dummy", phone: "123", topic: "Digital Marketing Course" },
        { date: "5/13/2026", name: "Anshu Kiran Sahay", phone: "00447535925291", topic: "Data Analyst Course with AI" },
        { date: "4/17/2026", name: "rohan", phone: "7409723438", topic: "Why Learn Python in 2026" },
        { date: "4/10/2026", name: "Saurabh", phone: "123456", topic: "What is python and AI in python" }
    ]);

    // 🔥 Auto-Load Client Data, WP Config & AI KNOWLEDGE
    useEffect(() => {
        const fetchTenantData = async () => {
            if (selectedTenantId) {
                const tenant = tenants.find(t => t.id === selectedTenantId);
                if (tenant) {
                    setBusinessName(tenant.name || "");
                    setWhatsappPhone(tenant.coordinator || tenant.whatsappId || "");
                    setNiche(tenant.category || "Education");

                    try {
                        const docRef = doc(db, "clients", selectedTenantId);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            const data = docSnap.data();
                            
                            if (data.wordpressConfig) {
                                setWpConfig(data.wordpressConfig);
                            } else {
                                setWpConfig({ url: '', username: '', appPassword: '' });
                            }
                            setAiKnowledge(data.aiKnowledge || "");
                            setAiRules(data.aiRules || "");
                        }
                    } catch (e) { console.error("Error fetching client DB config"); }
                }
            } else {
                setWpConfig({ url: '', username: '', appPassword: '' });
                setAiKnowledge("");
                setAiRules("");
            }
        };
        fetchTenantData();
    }, [selectedTenantId, tenants]);

    // 💾 Save WP Config (WITH SMART SAAS URL AUTOCORRECTOR)
    const handleSaveWpConfig = async () => {
        if (!selectedTenantId) return alert("Please select a business client first from the dropdown!");
        if (!wpConfig.url || !wpConfig.username || !wpConfig.appPassword) return alert("Fill all WP fields!");
        
        try {
            // 🔥 SAAS URL AUTO-CORRECTOR 🔥
            let cleanUrl = wpConfig.url.trim().toLowerCase();
            
            if (!/^https?:\/\//i.test(cleanUrl)) {
                cleanUrl = 'https://' + cleanUrl;
            }
            if (cleanUrl.endsWith('/')) {
                cleanUrl = cleanUrl.slice(0, -1);
            }

            const finalConfig = { ...wpConfig, url: cleanUrl };
            
            await updateDoc(doc(db, "clients", selectedTenantId), { wordpressConfig: finalConfig });
            setWpConfig(finalConfig);
            setShowWpModal(false);
            alert(`✅ WordPress connected successfully for ${businessName}!`);
        } catch (error) { alert("❌ Error saving WP config: " + error.message); }
    };

    // 🔥 SECURE AI CALL: Topic Suggestion
    const suggestTopic = async () => {
        if(!niche) return alert("Enter a niche first.");
        try {
            document.getElementById('topic-input').placeholder = "AI is thinking based on client niche...";
            
            const prompt = `Act as an SEO Strategist for "${niche}". Generate ONE highly engaging, "Long-Tail" educational blog title. 
            Business Context: ${aiKnowledge ? aiKnowledge.substring(0, 300) : 'General Education'}
            Return ONLY the exact title string.`;
            
            const response = await fetch(API_GENERATE_SEO, { 
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify({ prompt: prompt }) 
            });
            const data = await response.json();
            
            if(data.success) {
                setTopic(data.text.replace(/["']/g, '').trim());
            } else {
                alert("Backend Error: " + data.error);
            }
        } catch (error) { console.error(error); }
    };

  // 🔥 SMART PREMIUM FEATURED IMAGE GENERATOR 🔥
    const createCoverImage = async (searchKeyword, blogTitle, brandName) => {
        return new Promise(async (resolve) => {
            try {
                const cleanKw = searchKeyword.split(' ').slice(0, 1).join(' ').replace(/[^a-zA-Z0-9 ]/g, "");
                const searchTerms = cleanKw.length > 2 ? `${cleanKw} professional` : "modern workspace";

                const pexelsRes = await fetch(`https://api.pexels.com/v1/search?query=${encodeURIComponent(searchTerms)}&per_page=15&orientation=landscape`, { headers: { 'Authorization': PEXELS_API_KEY } });
                const pexelsData = await pexelsRes.json();
                
                let imageUrl = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200&q=80'; 
                if (pexelsData.photos && pexelsData.photos.length > 0) {
                    imageUrl = pexelsData.photos[Math.floor(Math.random() * pexelsData.photos.length)].src.large;
                }

                const img = new Image(); img.crossOrigin = "Anonymous";
                img.onload = () => {
                    const canvas = document.createElement('canvas'); canvas.width = 1200; canvas.height = 630; 
                    const ctx = canvas.getContext('2d');
                    
                    // 1. Draw Background Image
                    const scale = Math.max(canvas.width / img.width, canvas.height / img.height);
                    const x = (canvas.width / 2) - (img.width / 2) * scale;
                    const y = (canvas.height / 2) - (img.height / 2) * scale;
                    ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
                    
                    // 2. Add Smooth Dark Overlay
                    const grd = ctx.createLinearGradient(0, 0, 0, canvas.height);
                    grd.addColorStop(0, "rgba(15, 23, 42, 0.75)"); // Thoda aur dark kiya for readability
                    grd.addColorStop(1, "rgba(15, 23, 42, 0.95)");
                    ctx.fillStyle = grd; ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // 3. Setup Text alignment
                    ctx.textAlign = "center"; 
                    ctx.textBaseline = "middle";

                    // 4. Smart Word Wrap Logic
                    const cleanTitle = blogTitle.replace(/["']/g, ''); // Extra quotes hata diye
                    ctx.font = "900 68px sans-serif"; // Thoda sleek font size
                    const words = cleanTitle.split(' '); 
                    let lines = [];
                    let currentLine = words[0];

                    for (let i = 1; i < words.length; i++) {
                        let word = words[i];
                        let width = ctx.measureText(currentLine + " " + word).width;
                        if (width < 1050) { // Max width 1050px rakhi hai padding ke liye
                            currentLine += " " + word;
                        } else {
                            lines.push(currentLine);
                            currentLine = word;
                        }
                    }
                    lines.push(currentLine);

                    // 5. Dynamic Vertical Centering (Depending on total lines)
                    const lineHeight = 85;
                    const totalTextHeight = lines.length * lineHeight;
                    // Start Y position so that the whole block is perfectly centered
                    const startY = (canvas.height - totalTextHeight) / 2 + (lineHeight / 2) + 20;

                    // 6. Draw Brand Name (Placed perfectly above the title lines)
                    ctx.font = "bold 32px sans-serif"; 
                    ctx.fillStyle = "#34d399"; // Emerald color
                    ctx.fillText((brandName||"BRAND").toUpperCase(), canvas.width / 2, startY - 70);

                    // 7. Draw Title Lines
                    ctx.font = "900 68px sans-serif"; 
                    ctx.fillStyle = "#ffffff";
                    lines.forEach((line, index) => {
                        ctx.fillText(line, canvas.width / 2, startY + (index * lineHeight));
                    });

                    // 8. Convert to Blob
                    canvas.toBlob((blob) => resolve({ blob, dataUrl: canvas.toDataURL('image/jpeg', 0.9) }), 'image/jpeg', 0.9);
                };
                img.onerror = () => resolve(null); img.src = imageUrl;
            } catch (err) { resolve(null); }
        });
    };

    // 🔥 SECURE AI CALL: Blog Generation
    const generateBlog = async () => {
        if(!selectedTenantId) return alert("Select a business client first from the dropdown!");
        if(!topic) return alert("Please enter a topic first!");
        
        setIsGenerating(true); setGeneratedHtml(""); setCoverImage(null); setSeoData(null);

        try {
            let formatInstructions = formatRule === "Lesson" ? `Write this as a Step-by-Step Educational Lesson.` : `Write as an Ultimate Marketing Guide.`;
            let toneInstructions = toneRule === "Teacher" ? `Write like a supportive teacher mentoring a student.` : `Strict, professional corporate tone.`;

            const prompt = `Act as an elite SEO Content Writer for "${businessName}" (niche: "${niche}") in ${location || "India"}. Target Keyword: "${keyword || topic}". Topic: "${topic}".
            
            CRITICAL BUSINESS INFORMATION (Naturally weave these facts into the content):
            ${aiKnowledge ? aiKnowledge : "Write standard high-quality content."}
            
            BRAND RULES & TONE:
            ${aiRules ? aiRules : "Be highly engaging and authoritative."}
            ${formatInstructions} ${toneInstructions}

            Output THREE strictly defined blocks: [SEO_DATA], [BLOG_HTML] and [QUIZ_JSON].

            [SEO_DATA]
            {"meta_title": "SEO Optimized Title", "meta_description": "Compelling description integrating keyword", "slug": "seo-url-slug"}
            [/SEO_DATA]

            [BLOG_HTML]
            Write a comprehensive 800+ words SEO blog. Format with proper HTML tags (<p>, <h3>, <ul>). 
            Use inline styles: <p style="margin-bottom: 1.2rem; line-height: 1.8; color: #334155;"> and <h3 style="font-size: 1.6rem; font-weight: 800; color: #0f172a; margin-top: 2rem;">.
            Include 2 image placeholders like <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3" alt="Tech" style="width:100%; border-radius:10px; margin: 2rem 0;">.
            [/BLOG_HTML]

            [QUIZ_JSON]
            Generate exactly 5 multiple choice questions relevant to the content.
            [{"question": "Q1?", "options": ["A", "B", "C", "D"], "correctIndex": 0, "explanation": "A is correct."}]
            [/QUIZ_JSON]
            `;

            // 🔒 CALLING THE SECURE CLOUD FUNCTION
            const response = await fetch(API_GENERATE_SEO, {
                method: 'POST', 
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: prompt })
            });

            const data = await response.json();
            if (!data.success) throw new Error("AI Generation failed. Check backend logs.");
            
            const fullText = data.text;
            
            const seoMatch = fullText.match(/\[SEO_DATA\]([\s\S]*?)\[\/SEO_DATA\]/i);
            const htmlMatch = fullText.match(/\[BLOG_HTML\]([\s\S]*?)\[\/BLOG_HTML\]/i);
            const jsonMatch = fullText.match(/\[QUIZ_JSON\]([\s\S]*?)\[\/QUIZ_JSON\]/i);
            
            if (!htmlMatch) throw new Error("AI returned invalid format.");
            let aiHtml = htmlMatch[1].trim();

            if (seoMatch) {
                try {
                    const parsedSeo = JSON.parse(seoMatch[1].replace(/```json/gi, '').replace(/```/gi, '').trim());
                    setSeoData(parsedSeo);
                    setGeneratedTitle(parsedSeo.meta_title);
                } catch(e) {}
            }

            // 🔥 LEAD GENERATION WIDGET LOGIC (Pointing to pivot-rank.web.app) 🔥
            if (jsonMatch && formatRule === "Lesson") {
                try {
                    let quizArray = JSON.parse(jsonMatch[1].replace(/```json/gi, '').replace(/```/gi, '').trim());
                    // Save Quiz to DB for the client
                    const quizDocRef = await addDoc(collection(db, "blog_quizzes"), {
                        client_id: selectedTenantId,
                        business_name: businessName,
                        topic: topic,
                        whatsapp: whatsappPhone.replace(/\D/g,''),
                        questions: quizArray,
                        timestamp: serverTimestamp()
                    });
                    
                    aiHtml += `
                    <div style="margin: 3rem 0; width: 100%; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1); border: 2px solid #e2e8f0; background: #f8fafc;">
                        <iframe src="https://pivot-rank.web.app/quiz-widget.html?id=${quizDocRef.id}" width="100%" height="750" frameborder="0" scrolling="yes" style="border: none; background: transparent;"></iframe>
                    </div>`;
                } catch(e) { console.error("Quiz Error", e); }
            }

            // WhatsApp CTA Banner
            const cleanPhone = whatsappPhone.replace(/\D/g, '');
            aiHtml += `
            <div style="margin-top: 3rem; padding: 2.5rem; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 1.5rem; color: white; text-align: center; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.2);">
                <h3 style="font-size: 1.8rem; font-weight: 900; color: white; margin-bottom: 1rem;">Transform Your Career with ${businessName}</h3>
                <p style="color: #cbd5e1; margin-bottom: 2rem;">Secure your future with expert guidance.</p>
                <a href="${cleanPhone ? 'https://wa.me/' + cleanPhone + '?text=Hi ' + encodeURIComponent(businessName) + ', I read your blog and want to know more.' : '#'}" target="_blank" style="display: inline-block; background-color: #25D366; color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 900; text-decoration: none;">💬 Message Us on WhatsApp</a>
            </div>`;

            if(autoImage) {
                const imgResult = await createCoverImage(keyword||topic, seoData?.meta_title || topic, businessName);
                if(imgResult) setCoverImage(imgResult);
            }

            setGeneratedHtml(aiHtml);
        } catch (error) { alert("Generation Error: " + error.message); }
        finally { setIsGenerating(false); }
    };

    // 🔥 RAW HTML COPIER
    const copyToClipboard = () => {
        if (!generatedHtml) return;
        navigator.clipboard.writeText(`<h1>${generatedTitle}</h1>\n${generatedHtml}`)
            .then(() => alert("HTML Copied to clipboard!"))
            .catch(err => alert("Failed to copy HTML"));
    };

    // 🔥 100% BULLETPROOF WP PUBLISHER (VIA BACKEND) 🔥
    const handlePublishToWP = async () => {
        if(!wpConfig.url) return alert("Website connected nahi hai! Upar 'WP Setup' par click karke details daalein.");
        setIsPublishing(true);
        
        try {
            // Frontend sends the Base64 Image and text to Firebase Backend
            const payload = {
                wpUrl: wpConfig.url,
                username: wpConfig.username,
                appPassword: wpConfig.appPassword,
                title: generatedTitle,
                content: generatedHtml,
                seoData: seoData,
                imageBase64: coverImage ? coverImage.dataUrl : null
            };

            const response = await fetch(API_PUBLISH_WP, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                if (data.hasImage) {
                    alert("🎉 Success! Blog (with Cover Image) sent to WordPress Admin for Approval.");
                } else {
                    alert("🎉 Success! Blog Text sent to WordPress Admin. (Image skipped).");
                }
            } else {
                throw new Error(data.error || "Backend failed to publish.");
            }
        } catch (error) { 
            alert(`❌ Publish Failed: ${error.message}`); 
        } finally { 
            setIsPublishing(false); 
        }
    };

    // 🚦 ADMIN APPROVAL LOGIC (VIA SECURE BACKEND PROXY)
    const fetchPendingBlogs = async () => {
        if(!selectedTenantId) return alert("Select a business client first from the dropdown!");
        if(!wpConfig.url) return alert("Connect WordPress first to view pending blogs for this client.");
        
        setIsFetchingPending(true); setShowApprovalModal(true);
        
        try {
            const payload = {
                wpUrl: wpConfig.url,
                username: wpConfig.username,
                appPassword: wpConfig.appPassword
            };

            const res = await fetch(API_FETCH_PENDING, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await res.json();
            if(data.success) {
                setPendingBlogs(data.posts);
            } else {
                setPendingBlogs([]);
                console.error("Backend failed to fetch posts");
            }
        } catch(e) { 
            console.error("Fetch error:", e);
            setPendingBlogs([]); 
        } finally { 
            setIsFetchingPending(false); 
        }
    };

    // Note: Action for Publish/Trash goes directly to WP. 
    // If client hits CORS here, recommend backend proxy for this too in the future.
    const handlePostAction = async (postId, action) => {
        const authToken = btoa(`${wpConfig.username}:${wpConfig.appPassword}`);
        try {
            if (action === 'publish') {
                await fetch(`${wpConfig.url}/wp-json/wp/v2/posts/${postId}`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Basic ${authToken}` }, body: JSON.stringify({ status: 'publish' }) });
                alert("✅ Blog Published Live!");
            } else if (action === 'trash') {
                await fetch(`${wpConfig.url}/wp-json/wp/v2/posts/${postId}`, { method: 'DELETE', headers: { 'Authorization': `Basic ${authToken}` } });
                alert("🗑️ Blog Trashed.");
            }
            setPendingBlogs(pendingBlogs.filter(p => p.id !== postId));
        } catch(e) { alert("Action failed."); }
    };

    // 🔥 V6.0 EXACT UI MATCH 🔥
    return (
        <div className="max-w-5xl mx-auto pb-12 animate-in fade-in font-sans">
            
            {/* 🎯 HEADER SECTION V6 */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
                <div className="flex items-center gap-3">
                    <div className="bg-[#eef2ff] p-3 rounded-xl"><Database className="text-indigo-600" size={24}/></div>
                    <div>
                        <h2 className="text-2xl font-black text-slate-800 tracking-tight">Edu-Blog Lead Engine V6.0</h2>
                        <p className="text-[11px] text-slate-500 font-medium">Generate high-ranking lessons and track your captured leads.</p>
                    </div>
                </div>
                <div className="flex gap-3 w-full md:w-auto">
                    {/* WP SETUP BUTTON */}
                    <button onClick={() => setShowWpModal(true)} className="flex-1 md:flex-none px-5 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-bold rounded-xl transition-all shadow-sm flex items-center justify-center gap-2">
                        <Settings size={16}/> WP Setup
                    </button>
                    {/* VIEW LEADS BUTTON */}
                    <button 
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowLeadsModal(true); // Modal Popup Kholega
                        }}
                        className="flex-1 md:flex-none px-5 py-2.5 bg-emerald-100 hover:bg-emerald-200 text-emerald-800 text-sm font-bold rounded-xl transition-all flex items-center justify-center gap-2 active:scale-95 shadow-sm"
                    >
                        <LayoutTemplate size={16}/> View My Leads
                    </button>
                </div>
            </div>

            {/* 🟡 APPROVAL BANNER V6 */}
            <div className="bg-[#fffbeb] border border-amber-200 rounded-2xl p-5 flex flex-col md:flex-row justify-between items-center gap-4 mb-8 shadow-sm">
                <div className="flex items-center gap-4">
                    <div className="bg-amber-100 p-2.5 rounded-full text-amber-500"><BellRing size={20}/></div>
                    <div>
                        <h4 className="font-black text-amber-900 text-sm">Admin Approval Center</h4>
                        <p className="text-[11px] font-medium text-amber-700">Review full content & approve for live publishing.</p>
                    </div>
                </div>
                <button onClick={fetchPendingBlogs} className="w-full md:w-auto bg-[#f59e0b] hover:bg-[#d97706] text-white px-6 py-2.5 rounded-xl text-sm font-bold shadow-md transition-all">
                    Review Pending Blogs
                </button>
            </div>

            {/* 🛠️ SETUP ENGINE FORM V6 */}
            <div className="bg-white p-6 md:p-8 rounded-[32px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 mb-8">
                <h3 className="text-xl font-bold text-indigo-600 mb-6">1. Setup Engine</h3>
                
                {/* SaaS Client Selection */}
                <div className="mb-6 p-4 bg-slate-50 border border-slate-200 rounded-2xl">
                    <label className="block text-[11px] font-black text-slate-500 uppercase tracking-widest mb-2 flex items-center gap-1"><Store size={14}/> Target Client (Select to Auto-fill)</label>
                    <select value={selectedTenantId} onChange={(e) => setSelectedTenantId(e.target.value)} className="w-full p-3 rounded-xl border border-slate-300 outline-none focus:border-indigo-500 font-bold text-slate-800 bg-white shadow-sm cursor-pointer">
                        <option value="">-- Choose Business --</option>
                        {tenants && tenants.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 flex items-center gap-1">NICHE <BookOpen size={12}/></label>
                        <input type="text" value={niche} onChange={e=>setNiche(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-200 outline-none focus:border-indigo-500 text-slate-800 font-bold"/>
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 flex items-center gap-1">INSTITUTE NAME <Store size={12}/></label>
                        <input type="text" value={businessName} onChange={e=>setBusinessName(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-200 outline-none focus:border-indigo-500 text-slate-800 font-bold"/>
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 flex items-center gap-1">LEAD WHATSAPP NO. <Phone size={12}/></label>
                        <input type="text" value={whatsappPhone} onChange={e=>setWhatsappPhone(e.target.value)} className="w-full p-3.5 rounded-xl border border-emerald-300 outline-none bg-emerald-50 text-emerald-700 font-bold"/>
                    </div>
                </div>

                <div className="mb-6">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">TOPIC / LESSON TITLE <span className="text-rose-500">*</span></label>
                        <button onClick={suggestTopic} className="text-[10px] font-bold text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full hover:bg-indigo-100 transition-all flex items-center gap-1"><Sparkles size={12}/> Auto-Suggest Topic</button>
                    </div>
                    <input id="topic-input" type="text" value={topic} onChange={e=>setTopic(e.target.value)} className="w-full p-4 rounded-xl border border-slate-200 focus:border-indigo-500 text-sm font-medium outline-none text-slate-800 placeholder:text-slate-400 bg-slate-50/50" placeholder="e.g., What is Python? A Beginner's Lesson" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 flex items-center gap-1">TARGET CITY <MapPin size={12}/></label>
                            <input type="text" value={location} onChange={e=>setLocation(e.target.value)} placeholder="Dehradun" className="w-full p-3.5 rounded-xl border border-slate-200 bg-slate-50 text-sm font-medium focus:border-indigo-500 outline-none"/>
                        </div>
                        <div>
                            <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1 flex items-center gap-1">PRIMARY KEYWORD <KeyRound size={12}/></label>
                            <input type="text" value={keyword} onChange={e=>setKeyword(e.target.value)} placeholder="e.g. best institute" className="w-full p-3.5 rounded-xl border border-slate-200 bg-slate-50 text-sm font-medium focus:border-indigo-500 outline-none"/>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1">CONTENT FORMAT</label>
                            <select value={formatRule} onChange={e=>setFormatRule(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-200 text-sm font-bold bg-white cursor-pointer focus:border-indigo-500 outline-none">
                                <option value="Lesson">🎓 Step-by-Step Lesson (With 5 Q Quiz)</option>
                                <option value="Guide">📘 Ultimate Marketing Guide</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1">WRITING TONE</label>
                            <select value={toneRule} onChange={e=>setToneRule(e.target.value)} className="w-full p-3.5 rounded-xl border border-slate-200 text-sm font-bold bg-white cursor-pointer focus:border-indigo-500 outline-none">
                                <option value="Teacher">👩‍🏫 Supportive Teacher / Mentor</option>
                                <option value="Corporate">💼 Strict Corporate / Professional</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="bg-[#0f172a] text-white p-4 rounded-2xl flex justify-between items-center mb-6">
                    <div className="flex items-center gap-3">
                        <ImageIcon className="text-emerald-400" size={20}/>
                        <div>
                            <p className="text-sm font-bold">Auto-Branded Featured Image</p>
                            <p className="text-[10px] text-slate-400">Fetches an HD Pexels photo, adds a dark gradient, and prints your Title + Branding automatically.</p>
                        </div>
                    </div>
                    <div className="w-10 h-6 bg-emerald-500 rounded-full relative cursor-pointer" onClick={()=>setAutoImage(!autoImage)}>
                        <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-all ${autoImage ? 'right-1' : 'left-1 bg-slate-400'}`}></div>
                    </div>
                </div>

                <button onClick={generateBlog} disabled={isGenerating} className="w-full bg-[#8b5cf6] text-white font-bold py-4 rounded-2xl shadow-md hover:bg-[#7c3aed] transition-all text-base flex items-center justify-center gap-2 disabled:opacity-50">
                    {isGenerating ? <Loader2 className="animate-spin" size={18}/> : <><Sparkles size={18} /> Generate Lesson & Magic 🚀</>}
                </button>
            </div>

            {/* 👀 PREVIEW SECTION */}
            {generatedHtml && (
                <div className="mt-12 animate-in slide-in-from-bottom-8">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                        <div>
                            <h2 className="text-2xl font-black text-slate-900 flex items-center gap-2"><Eye size={20}/> Content Preview</h2>
                        </div>
                        <div className="flex gap-3 w-full md:w-auto">
                            <button onClick={handlePublishToWP} disabled={isPublishing} className="flex-1 md:flex-none px-8 py-3 bg-emerald-500 text-white font-bold rounded-xl shadow-md hover:bg-emerald-600 flex items-center justify-center gap-2 disabled:opacity-50">
                                {isPublishing ? <Loader2 size={16} className="animate-spin"/> : <Send size={16}/>} Send to WP Admin
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-200 overflow-hidden flex flex-col md:flex-row">
                        {/* Editor Side */}
                        <div className="w-full md:w-2/3 p-6 md:p-10 border-b md:border-b-0 md:border-r border-slate-100">
                            <input type="text" value={generatedTitle} onChange={e=>setGeneratedTitle(e.target.value)} className="w-full text-2xl md:text-3xl font-black text-slate-900 border-none outline-none mb-6 focus:ring-0 placeholder:text-slate-300" placeholder="Blog Title..." />
                            
                            {coverImage && (
                                <div className="mb-8 relative group rounded-2xl overflow-hidden border border-slate-100 shadow-sm">
                                    <img src={coverImage.dataUrl} alt="Cover" className="w-full h-auto object-cover aspect-[1200/630]" />
                                    <div className="absolute top-2 right-2 bg-black/60 text-white text-[10px] font-bold px-2 py-1 rounded-lg backdrop-blur-sm">AI Generated Cover</div>
                                </div>
                            )}

                            <div className="prose prose-slate max-w-none prose-p:text-slate-600 prose-headings:text-slate-900" dangerouslySetInnerHTML={{__html: generatedHtml}}></div>
                        </div>

                        {/* Sidebar */}
                        <div className="w-full md:w-1/3 bg-slate-50 p-6 md:p-8 flex flex-col gap-6">
                            <div>
                                <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 flex items-center gap-2"><Database size={14}/> SEO Metadata</h4>
                                <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm space-y-3">
                                    <div>
                                        <p className="text-[9px] font-bold text-slate-400 uppercase mb-1">URL Slug</p>
                                        <p className="text-xs text-indigo-600 font-mono truncate">{seoData?.slug || "not-generated"}</p>
                                    </div>
                                    <div>
                                        <p className="text-[9px] font-bold text-slate-400 uppercase mb-1">Meta Description</p>
                                        <p className="text-xs text-slate-700 leading-relaxed line-clamp-3">{seoData?.meta_description || "Not generated."}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="mt-auto">
                                <button onClick={copyToClipboard} className="w-full px-4 py-4 bg-slate-800 text-white font-bold rounded-xl shadow-lg hover:bg-black flex items-center justify-center gap-2 transition-all">
                                    <Copy size={16}/> Copy Raw HTML
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ⚙️ WP SETUP MODAL (PER CLIENT) */}
            {showWpModal && (
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in zoom-in duration-200">
                    <div className="bg-white rounded-3xl w-full max-w-md p-8 shadow-2xl border border-slate-200">
                        <div className="flex justify-between items-center mb-2">
                            <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center"><Settings size={24}/></div>
                            <button onClick={() => setShowWpModal(false)} className="text-slate-400 hover:bg-rose-50 hover:text-rose-600 p-2 rounded-full transition-colors"><X size={20}/></button>
                        </div>
                        <h3 className="text-xl font-black text-slate-800 tracking-tight">Connect Website</h3>
                        <p className="text-xs font-medium text-slate-500 mb-6 mt-1">
                            Link WordPress site for <span className="font-bold text-indigo-600">{businessName || 'this client'}</span>.
                        </p>
                        
                        {!selectedTenantId ? (
                            <div className="p-4 bg-rose-50 text-rose-600 rounded-xl text-sm font-bold text-center border border-rose-100">
                                Please select a Target Client from the dropdown first!
                            </div>
                        ) : (
                            <div className="space-y-4">
                                <div>
                                    <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Website URL</label>
                                    <input type="url" value={wpConfig.url} onChange={e=>setWpConfig({...wpConfig, url: e.target.value})} placeholder="https://yourwebsite.com" className="w-full p-3.5 rounded-xl border border-slate-200 mt-1 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-50 outline-none font-medium text-sm"/>
                                </div>
                                <div>
                                    <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">WP Username</label>
                                    <input type="text" value={wpConfig.username} onChange={e=>setWpConfig({...wpConfig, username: e.target.value})} placeholder="admin" className="w-full p-3.5 rounded-xl border border-slate-200 mt-1 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-50 outline-none font-medium text-sm"/>
                                </div>
                                <div>
                                    <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">App Password</label>
                                    <input type="password" value={wpConfig.appPassword} onChange={e=>setWpConfig({...wpConfig, appPassword: e.target.value})} placeholder="xxxx xxxx xxxx xxxx" className="w-full p-3.5 rounded-xl border border-slate-200 mt-1 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-50 outline-none font-mono text-sm"/>
                                    <p className="text-[10px] text-slate-400 mt-1.5 ml-1">Generate from WP Admin &rarr; Users &rarr; Profile &rarr; App Passwords.</p>
                                </div>
                                <button onClick={handleSaveWpConfig} className="w-full mt-4 bg-indigo-600 text-white font-black uppercase tracking-widest py-4 rounded-xl hover:bg-indigo-700 shadow-lg shadow-indigo-200 transition-all active:scale-95">Save Connection</button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* 🚦 ADMIN APPROVAL MODAL */}
            {showApprovalModal && (
                <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-in zoom-in duration-200">
                    <div className="bg-white rounded-[32px] w-full max-w-4xl h-[85vh] shadow-2xl flex flex-col border border-slate-200 overflow-hidden">
                        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-[#fffbeb]">
                            <div className="flex items-center gap-3">
                                <div className="bg-[#f59e0b] p-2.5 rounded-xl text-white"><CheckCircle2 size={24}/></div>
                                <div>
                                    <h3 className="text-xl font-black text-slate-900 tracking-tight">Pending Blogs</h3>
                                    <p className="text-[10px] font-bold text-amber-700 uppercase tracking-widest mt-0.5">Review before going live</p>
                                </div>
                            </div>
                            <button onClick={() => setShowApprovalModal(false)} className="bg-white text-slate-400 hover:bg-rose-50 hover:text-rose-600 p-2.5 rounded-full transition-colors shadow-sm border border-slate-200"><X size={20}/></button>
                        </div>
                        
                        <div className="flex-1 overflow-y-auto p-6 bg-slate-50 custom-scrollbar">
                            {isFetchingPending ? (
                                <div className="flex flex-col items-center justify-center h-full text-slate-400 space-y-4">
                                    <Loader2 size={32} className="animate-spin text-amber-500" />
                                    <p className="text-xs font-bold uppercase tracking-widest text-slate-500">Scanning Website...</p>
                                </div>
                            ) : pendingBlogs.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-full text-slate-400 space-y-4 text-center">
                                    <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm"><CheckCircle2 size={40} className="text-emerald-400 opacity-50"/></div>
                                    <p className="text-lg font-black text-slate-600">All Caught Up!</p>
                                    <p className="text-sm">No pending blogs found on this website.</p>
                                </div>
                            ) : (
                                <div className="space-y-6">
                                    {pendingBlogs.map(post => (
                                        <div key={post.id} className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm relative">
                                            <span className="absolute top-6 right-6 bg-amber-100 text-amber-800 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest">Needs Review</span>
                                            <h4 className="font-black text-xl text-slate-800 mb-4 pr-32" dangerouslySetInnerHTML={{__html: post.title.rendered}}></h4>
                                            
                                            <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 mb-5 max-h-[250px] overflow-y-auto prose prose-sm max-w-none custom-scrollbar shadow-inner relative">
                                                <div className="sticky top-0 bg-slate-50/90 backdrop-blur-sm pb-2 mb-2 border-b border-slate-200 text-[10px] font-black text-indigo-600 uppercase tracking-widest">Content Preview:</div>
                                                <div dangerouslySetInnerHTML={{__html: post.content.rendered}}></div>
                                            </div>
                                            
                                            <div className="flex gap-3 justify-end mt-2">
                                                <a href={`${wpConfig.url}/wp-admin/post.php?post=${post.id}&action=edit`} target="_blank" rel="noreferrer" className="px-5 py-2.5 bg-slate-100 text-slate-700 hover:bg-slate-200 rounded-xl text-xs font-bold transition flex items-center gap-2"><LinkIcon size={14}/> Edit in WP</a>
                                                <button onClick={() => handlePostAction(post.id, 'trash')} className="px-5 py-2.5 bg-rose-50 text-rose-600 hover:bg-rose-600 hover:text-white rounded-xl text-xs font-bold transition flex items-center gap-2"><Trash2 size={14}/> Trash</button>
                                                <button onClick={() => handlePostAction(post.id, 'publish')} className="px-6 py-2.5 bg-emerald-500 text-white hover:bg-emerald-600 rounded-xl text-xs font-black transition shadow-md flex items-center gap-2"><Send size={14}/> Publish Live</button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* 📊 NAYA CODE: LEAD MANAGER CRM MODAL (With Date Sorting) */}
            {showLeadsModal && (
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[110] p-4 animate-in zoom-in duration-200">
                    <div className="bg-white rounded-[32px] w-full max-w-5xl shadow-2xl flex flex-col overflow-hidden border border-slate-200">
                        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                            <div className="flex items-center gap-4">
                                <div className="bg-white p-3 rounded-2xl shadow-sm text-indigo-600 border border-slate-200">
                                    <LayoutTemplate size={28}/>
                                </div>
                                <div>
                                    <h3 className="text-2xl font-black text-slate-800 tracking-tight">Lead Manager CRM</h3>
                                    <p className="text-sm font-medium text-slate-500 mt-1">Track students who passed quizzes or requested syllabus across all blogs.</p>
                                </div>
                            </div>
                            <button onClick={() => setShowLeadsModal(false)} className="bg-white text-slate-400 hover:bg-rose-50 hover:text-rose-600 p-3 rounded-full transition-colors border border-slate-200 shadow-sm"><X size={24}/></button>
                        </div>
                        <div className="p-6 overflow-x-auto bg-white min-h-[400px]">
                            <table className="w-full text-left border-collapse">
                                <thead>
                                    <tr className="text-[11px] font-black text-slate-400 uppercase tracking-widest border-b-2 border-slate-100">
                                        <th className="p-4 pb-4">Date</th>
                                        <th className="p-4 pb-4">Student Name</th>
                                        <th className="p-4 pb-4">WhatsApp No.</th>
                                        <th className="p-4 pb-4">Source Blog Topic</th>
                                        <th className="p-4 pb-4">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...blogLeads]
                                        .sort((a, b) => new Date(b.date) - new Date(a.date)) // 🔥 Date Sorting
                                        .map((lead, idx) => (
                                        <tr key={idx} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                                            <td className="p-4 text-sm font-medium text-slate-500">{lead.date}</td>
                                            <td className="p-4 text-sm font-black text-slate-800">{lead.name}</td>
                                            <td className="p-4 text-sm font-black text-emerald-600">{lead.phone}</td>
                                            <td className="p-4 text-sm font-bold text-indigo-600">{lead.topic}</td>
                                            <td className="p-4">
                                                <button className="flex items-center gap-2 bg-emerald-50 text-emerald-600 px-4 py-2 rounded-xl text-xs font-bold hover:bg-emerald-100 transition-colors shadow-sm">
                                                    💬 Message
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SeoBlogEngine;